import { lazy } from "react";

export function lazyImportPath(path) {
  return lazy(() => {
    return import(`@/${path}`);
  });
}
